import axios from "axios";
import common from "../utils/common";

const otherApi = {
  postImage: async (fileName, file) => {
    const data = new FormData();
    data.append("fileName", fileName?.replaceAll("|", "-"));
    data.append("file", file);

    try {
      var config = {
        method: "post",
        url: "https://upload.imagekit.io/api/v2/files/upload",
        headers: {
          Authorization:
            "Basic cHJpdmF0ZV9yajF4UlJYWk41L21tL2xNdEpKMlpYOE5oVUE9Og==",
        },
        data: data,
      };

      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  postImageDropbox: async (dropboxAccessToken, fileName, file) => {
    const safeName = common.removeVietnameseTones(fileName?.replaceAll("|", "-"));

    try {
      const res = await axios.post(
        "https://content.dropboxapi.com/2/files/upload",
        file, // body là binary
        {
          headers: {
            Authorization: `Bearer ${dropboxAccessToken}`,
            "Content-Type": "application/octet-stream",
            "Dropbox-API-Arg": JSON.stringify({
              path: `/akachat/${safeName}`,
              mode: "add",
              autorename: true,
            }),
          },
        }
      );
      return await otherApi.createSharedLinkDropbox(
        dropboxAccessToken,
        res.data.path_display
      );
    } catch (error) {
      console.error(
        "Dropbox upload error:",
        error?.response?.data || error.message
      );
      throw error;
    }
  },
  createSharedLinkDropbox: async (dropboxAccessToken, path) => {
    try {
      const res = await axios.post(
        "https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings",
        { path },
        { headers: { Authorization: `Bearer ${dropboxAccessToken}` } }
      );
      return res.data; // link chia sẻ lâu dài
    } catch (err) {
      const status = err?.response?.status;
      const tag =
        err?.response?.data?.[".tag"] || err?.response?.data?.error?.[".tag"];

      // 2) nếu đã tồn tại link -> lấy lại bằng list_shared_links
      if (status === 409) {
        try {
          const listRes = await axios.post(
            "https://api.dropboxapi.com/2/sharing/list_shared_links",
            { path, direct_only: true },
            { headers: { Authorization: `Bearer ${dropboxAccessToken}` } }
          );
          const existing = listRes.data.links?.[0];
          if (existing) return existing;
        } catch (listErr) {
          console.error(
            "list_shared_links error:",
            listErr?.response?.data || listErr.message
          );
          throw listErr;
        }
      }

      console.error(
        "create_shared_link error:",
        err?.response?.data || err.message
      );
      throw err;
    }
  },
  getDropboxToken: () => {
    const url = `https://app.akabiz.net/api/Auth/getDropboxToken`;
    return axios.get(url);
  },
  updateDropboxAccessToken: () => {
    const url = `https://app.akabiz.net/api/Dropbox/updateAccessTokenFromRefreshToken`;
    return axios.get(url);
  },
};
export default otherApi;
